<section class="extractions-chart surface-card" [class.is-collapsed]="collapsed">
  <header class="extractions-chart__head">
    <button type="button" class="extractions-chart__toggle" (click)="toggleCollapsed()" [attr.aria-expanded]="!collapsed">
      <span class="extractions-chart__caret" [class.is-open]="!collapsed">▸</span>
      <span class="extractions-chart__titles">
        <span class="extractions-chart__title experimental-marker" [title]="'audiences.extractions.experimentalHint' | translate">
          {{ 'audiences.extractions.title' | translate }}
        </span>
        <span class="extractions-chart__subtitle">{{ 'audiences.extractions.subtitle' | translate }}</span>
      </span>
    </button>

    <!-- Collapsed preview: a mini sparkline of the same data, so you get the gist without expanding. -->
    <div class="extractions-chart__preview" *ngIf="collapsed && hasPreview" (click)="toggleCollapsed()">
      <app-audience-extractions-sparkline [data]="data" [mini]="true"></app-audience-extractions-sparkline>
    </div>
  </header>

  <div class="extractions-chart__body" *ngIf="!collapsed">
    <p class="extractions-chart__state" *ngIf="loading">{{ 'common.loading' | translate }}</p>
    <p class="extractions-chart__state error" *ngIf="!loading && error">{{ 'audiences.extractions.error' | translate }}</p>
    <app-audience-extractions-sparkline *ngIf="!loading && !error" [data]="data"></app-audience-extractions-sparkline>
  </div>
</section>
